import type {UrlFilters, UrlFilterSchema, UrlFilterValue} from './types';

import {TRUE_QUERY_VALUES} from './constants';

export const deserializeUrlFilters = <TFilters extends object>(
  searchParams: URLSearchParams,
  schema: UrlFilterSchema<TFilters>
): TFilters => {
  const filters: UrlFilters = {};

  Object.entries(schema).forEach(([key, type]) => {
    if (type === 'array') {
      const values = searchParams.getAll(key).filter(Boolean);
      filters[key] = values.length > 0 ? values : undefined;
      return;
    }

    const value = searchParams.get(key);
    if (type === 'boolean') {
      filters[key] = value === null ? undefined : TRUE_QUERY_VALUES.has(value);
      return;
    }

    filters[key] = value || undefined;
  });

  return filters as TFilters;
};

export const serializeUrlFilters = <TFilters extends object>(
  filters: TFilters,
  schema: UrlFilterSchema<TFilters>
) => {
  const searchParams = new URLSearchParams();

  Object.entries(schema).forEach(([key, type]) => {
    const value = (filters as Record<string, UrlFilterValue>)[key];
    if (value === undefined || value === false || value === '') {
      return;
    }

    if (type === 'array') {
      if (Array.isArray(value)) {
        value.filter(Boolean).forEach((item) => searchParams.append(key, item));
      }
      return;
    }

    searchParams.set(key, String(value));
  });

  return searchParams;
};
